export default __webpack_public_path__ + "static/media/caveTubing1.09e7ce90.webp";